import { Injectable } from "@angular/core";
import { StaffRequirementParametersService } from "lib-klab-sdks";
import { map, Observable } from "rxjs";
import { RequirementParametersPort } from "../../../app/ports/requirement/requirement-parameters.port";
import { RequirementParameter, RequirementParameterListRequest, RequirementParameterPage, RequirementParameterRequest } from "../../../domain/models/requirement/requirement-parameter.model";
import { mapRequirementParameter } from "../../mappers/requirement/requirement-parameter.mapper";

@Injectable({ providedIn: "root" })
export class RequirementParametersPortAdapter implements RequirementParametersPort {
  constructor(private readonly api: StaffRequirementParametersService) {}

  list(request: RequirementParameterListRequest = {}): Observable<RequirementParameterPage> {
    return this.api.list(request).pipe(map(({ data }) => ({ ...data, items: data.items.map(mapRequirementParameter) })));
  }

  get(id: number): Observable<RequirementParameter> {
    return this.api.get(id).pipe(map(({ data }) => mapRequirementParameter(data)));
  }

  getEffective(paramKey: string, companyId?: number): Observable<RequirementParameter> {
    return this.api.getEffective(paramKey, companyId).pipe(map(({ data }) => mapRequirementParameter(data)));
  }

  create(request: RequirementParameterRequest): Observable<RequirementParameter> {
    return this.api.create(request).pipe(map(({ data }) => mapRequirementParameter(data)));
  }

  update(id: number, request: RequirementParameterRequest): Observable<RequirementParameter> {
    return this.api.update(id, request).pipe(map(({ data }) => mapRequirementParameter(data)));
  }

  delete(id: number): Observable<void> {
    return this.api.delete(id).pipe(map(() => undefined));
  }
}
